module.exports = __webpack_public_path__ + "static/profile-coffee-3746b196d5e37d41f995fc8a52941d49.jpg";